import { isAuthenticated } from "../../Auth/helper";
import LoggedInNavbar from "./loggedInNavbar";
import { Link } from "react-router-dom";
import { MDBIcon } from "mdb-react-ui-kit";

const UserProfile = () => {
  // CHANGED: Added null check — since ProtectedRoutes no longer forces login,
  // user could land here without a token. Show a friendly message instead of crashing.
  const auth = isAuthenticated();
  const getdata = auth?.user;

  if (!getdata) {
    return (
      <>
        <LoggedInNavbar />
        <div style={{
          minHeight: "60vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", gap: 16,
        }}>
          <MDBIcon icon="user-circle" fas style={{ fontSize: 64, color: "#E34607" }} />
          <h2 style={{ color: "#333", fontWeight: 700 }}>Please sign in</h2>
          <p style={{ color: "#666" }}>Sign in to view your profile.</p>
          <Link to="/signin">
            <button style={{
              background: "#E34607", color: "white", border: "none",
              borderRadius: "8px", padding: "12px 28px",
              fontSize: "15px", fontWeight: "600", cursor: "pointer",
            }}>
              Sign In
            </button>
          </Link>
        </div>
      </>
    );
  }

  // CHANGED: Logout button removed from UI
  // To logout: visit /devlogout (developers only)
  // const handleLogout = () => { localStorage.clear(); navigate("/signin"); };

  return (
    <>
      <LoggedInNavbar />

      {/* Gradient Banner */}
      <div style={{
        background: "linear-gradient(135deg, #E34607 0%, #ff6b35 100%)",
        height: "200px", width: "100%",
        position: "relative", marginBottom: "80px",
      }}>
        <div style={{
          position: "absolute", bottom: "-60px",
          left: "50%", transform: "translateX(-50%)",
          width: "120px", height: "120px",
          borderRadius: "50%", background: "white",
          border: "4px solid white",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <MDBIcon icon="user" fas style={{ fontSize: "60px", color: "#E34607" }} />
        </div>
      </div>

      {/* Main Content */}
      <div style={{ maxWidth: "800px", margin: "0 auto", padding: "0 20px" }}>

        {/* User Info Section */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <h1 style={{
            fontSize: "32px", fontWeight: "700",
            color: "#333", marginBottom: "8px",
          }}>
            {getdata.Name}
          </h1>
          <p style={{ fontSize: "16px", color: "#666", marginBottom: "24px" }}>
            Hare Krishna Mandir Member
          </p>

          {/* Action Buttons — Logout removed, only Go to Library remains */}
          <div style={{
            display: "flex", gap: "16px",
            justifyContent: "center", marginBottom: "40px",
          }}>
            {/* REMOVED: Logout button
            <button onClick={handleLogout} ...>Logout</button>
            Logout is now only accessible via /devlogout for developers */}

            <Link to="/">
              <button
                style={{
                  background: "transparent", color: "#E34607",
                  border: "2px solid #E34607", borderRadius: "8px",
                  padding: "12px 24px", fontSize: "14px",
                  fontWeight: "500", cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#E34607";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "transparent";
                  e.target.style.color = "#E34607";
                }}
              >
                Go to Library
              </button>
            </Link>
          </div>
        </div>

        {/* Account Info Card */}
        <div style={{
          background: "white", borderRadius: "16px",
          padding: "32px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          border: "1px solid #f0f0f0",
        }}>
          <h2 style={{
            fontSize: "24px", fontWeight: "600",
            color: "#333", marginBottom: "24px", textAlign: "center",
          }}>
            Account Information
          </h2>

          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

            <div style={{
              display: "flex", alignItems: "center", padding: "16px",
              background: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef",
            }}>
              <MDBIcon icon="envelope" fas style={{
                fontSize: "18px", color: "#E34607",
                marginRight: "12px", width: "20px",
              }} />
              <div>
                <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>
                  Email Address
                </div>
                <div style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
                  {getdata.EmailId}
                </div>
              </div>
            </div>

            <div style={{
              display: "flex", alignItems: "center", padding: "16px",
              background: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef",
            }}>
              <MDBIcon icon="phone" fas style={{
                fontSize: "18px", color: "#E34607",
                marginRight: "12px", width: "20px",
              }} />
              <div>
                <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>
                  Mobile Number
                </div>
                <div style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
                  {getdata.MobileNo}
                </div>
              </div>
            </div>

            <div style={{
              display: "flex", alignItems: "flex-start", padding: "16px",
              background: "#f8f9fa", borderRadius: "8px", border: "1px solid #e9ecef",
            }}>
              <MDBIcon icon="map-marker-alt" fas style={{
                fontSize: "18px", color: "#E34607",
                marginRight: "12px", width: "20px", marginTop: "2px",
              }} />
              <div>
                <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>
                  Address
                </div>
                <div style={{
                  fontSize: "16px", fontWeight: "500",
                  color: "#333", lineHeight: "1.4",
                }}>
                  {getdata.Address}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <br />
    </>
  );
};

export default UserProfile;